/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2019 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H133162 on 7/18/2019.
 *
 */
import React from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {Grid, Table} from '@scuf/common';
import {fetchAffectedFaultsByPredictiveIndicator} from "../../api/PredictiveIndicators";
import Loader from "../../common/Loader";
import {withRouter} from "react-router";
import {getFaultName} from "../../utils/Helpers";

class PredictiveIndicatorDetail extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            faults: [],
        }
    }

    componentDidMount() {
        this.fetchPredictiveIndicatorDetail()
    }

    fetchPredictiveIndicatorDetail() {
        this.setState({loading: true});
        fetchAffectedFaultsByPredictiveIndicator(this.props.assetId, this.props.predictiveIndicator.id).then((faults) => {
            this.setState({faults: faults});
        }).then(() => this.setState({loading: false}));
    }

    processAffectedFaults(faults) {
        const {intl} = this.props
        return faults.map((f, i) => {
            const faultName = getFaultName(f)
            return (
                <React.Fragment>
                    <Table.Row className={this.getRowClass("extra-row mobile only", i)}>
                        <Table.Cell colSpan={3}>
                            {faultName}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row className={this.getRowClass("", i)}>
                        <Table.Cell className="computer only">
                            {faultName}
                        </Table.Cell>
                        <Table.Cell>
                            <div className={'state-' + f.faultConditionState}>
                                <div className='state-icon' />
                                <div className='state-name'>{f.faultConditionState ? intl.formatMessage({id: "fault.detail.state." + f.faultConditionState}) : ''}</div>
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            {f.assignedUser != null ? f.assignedUser.displayName : ''}
                        </Table.Cell>
                    </Table.Row>
                </React.Fragment>
            )
        })
    }

    getRowClass(className, index) {
        return className + ' ' + (index % 2 === 0 ? 'even' : 'odd')
    }

    renderPredictiveIndicatorDetail() {
        const {intl} = this.props
        const rows = this.processAffectedFaults(this.state.faults)
        return(
            <React.Fragment>
                <h5><FormattedMessage id="faults.tab.predictiveIndicators.affectedFaults" /></h5>
                <Grid>
                    <Grid.Row>
                        <Grid.Column>
                            {this.state.faults.length === 0 ?
                            <FormattedMessage id="faults.tab.predictiveIndicators.affectedFaults.empty"/>
                            :
                            <Table className="affected-faults unstackable">
                                <Table.Header>
                                    <Table.HeaderCell
                                        content={intl.formatMessage({id: "faults.tab.predictiveIndicators.affectedFaults.name"})}
                                        className="computer only half-wide-cell"/>
                                    <Table.HeaderCell className="quater-wide-cell"
                                                      content={intl.formatMessage({id: "faults.tab.predictiveIndicators.affectedFaults.state"})}/>
                                    <Table.HeaderCell className="quater-wide-cell"
                                                      content={intl.formatMessage({id: "faults.tab.predictiveIndicators.affectedFaults.assignee"})}/>
                                </Table.Header>
                                <Table.Body>
                                    {rows}
                                </Table.Body>
                            </Table>
                        }
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </React.Fragment>
        )
    }

    render() {
        return (
            <div className="predictive-indicator-detail">
                {this.renderPredictiveIndicatorDetail()}
                <Loader loading={this.state.loading}/>
            </div>
        )
    }
}

export default injectIntl(withRouter(PredictiveIndicatorDetail))

